import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum AddictionRoadAudio {
    INTRO = "addiction-road-n-intro.mp3",
    HOW_TO_MOVE = "addiction-road-n-1.mp3",
    WATCH_DEMO = "addiction-road-n-2.mp3",
    PRACTICE_ROUND = "addiction-road-n-3.mp3",
    REAL_ROUND = "addiction-road-n-4.mp3",
    WHEN_RACE_OVER = "addiction-road-n-5.mp3",
    GUESS_CORRECT = "addiction-road-n-right.mp3",
    GUESS_INCORRECT = "addiction-road-n-wrong.mp3",
    OUTRO = "addiction-road-n-outro.mp3",

    CAR_CRASH = "effects/car-crash.mp3",
    EXPLOSION = "effects/explosion.mp3",
    REV_AND_BEEPS = "effects/rev-and-beeps.mp3",
    RACING_ENGINE = "effects/racing-engine.mp3"
}

export enum AddictionRoadImages {
    ROAD = "road.png",
    TITLE = "title.png",

    CIG = "cig.png",
    ECIGARETTE = "ecigarette.png",
    CAR_CRASHED = "car-crashed.png",
    SMOKE = "smoke.png"
}

export enum AddictionRoadAtlases {
    ARROW_KEYS = "arrow-keys.json",
    CAR = "car.json",
    EXPLOSION = "explosion.json",
    MILE_POSTS = "mile-posts.json",
    SIGN = "sign.json",
    UI = "ui.json",
    READY_SET_GO = "ready-set-go.json"
}

export enum AddictionRoadExitAssets {
    BUDDY_TESTIMONIALS_INTRO = "AddictionRoadBUDDY_TESTIMONIALS_INTRO",
    OUTRO1 = "AddictionRoadOUTRO1",
}

export const loadAssets = (game: Phaser.Game) => {
    const load = PhaserUtils.makeLoader(game, "addiction-road")
    load.autoLoad({imageEnum: AddictionRoadImages, audioEnum: AddictionRoadAudio, atlasEnum: AddictionRoadAtlases})
}

